import { useState } from "react";
import { useAuth, ROLE_LABELS } from "@/contexts/AuthContext";
import { api, extractError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export default function Profile() {
  const { user, refetch } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [password, setPassword] = useState("");
  const [notifyEmail, setNotifyEmail] = useState(user?.notify_email !== false);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const payload = { name, phone, notify_email: notifyEmail };
      if (password) payload.password = password;
      await api.patch(`/users/${user.id}`, payload);
      toast.success("Perfil atualizado");
      setPassword("");
      refetch();
    } catch (e) { toast.error(extractError(e)); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-2xl space-y-6" data-testid="profile-page">
      <div>
        <div className="inline-block text-[10px] uppercase tracking-[0.3em] font-bold px-2 py-0.5 bg-[#FFD400] text-[#0B1F3A] rounded-sm">Conta</div>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tighter mt-2 text-[#0B1F3A]">Meu perfil</h1>
        <p className="text-sm text-[#6B7280] mt-1">{ROLE_LABELS[user?.role]} · {user?.email}</p>
      </div>

      <div className="border border-[#E5E7EB] bg-white rounded-md p-6 space-y-4">
        <div><Label>Nome</Label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="profile-name" /></div>
        <div><Label>Telefone</Label><Input value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="profile-phone" /></div>
        <div><Label>Nova senha (opcional)</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="profile-password" /></div>

        <div className="pt-2 border-t border-[#F1F2F4]">
          <div className="flex items-start justify-between gap-4">
            <div>
              <Label className="mb-0">Notificações por e-mail</Label>
              <p className="text-xs text-[#6B7280] mt-1">Receber e-mails automáticos sobre solicitações, atribuições, conclusões e cancelamentos.</p>
            </div>
            <Switch checked={notifyEmail} onCheckedChange={setNotifyEmail} data-testid="profile-notify-email" />
          </div>
        </div>

        <Button onClick={save} disabled={saving} className="bg-[#0B1F3A] hover:bg-[#081A32] text-white" data-testid="profile-save">
          {saving ? "Salvando…" : "Salvar alterações"}
        </Button>
      </div>
    </div>
  );
}
